import { Flex } from "antd"
import classname from "classname"

import Images from "../../../../../Images"
import { useEnrollmentModal } from "../EnrollmentModal/hooks/useEnrollmentModal"

import styles from "./HistoricalDataModeBanner.module.less"

const HistoricalDataModeBanner = () => {
  const { open } = useEnrollmentModal()
  const onClick = () => {
    open()
  }
  return (
    <Flex className={styles.banner} gap={8} align="center" justify="center">
      <img src={Images.bh_historical_data_banner} alt="Historical Data Banner" />
      <p className={styles.text}>
        You're in historical data mode. Reenroll to view newest data.{" "}
        <a onClick={onClick} className={classname(styles.text, styles.strong)}>
          Enroll in VAMP
        </a>{" "}
        →
      </p>
    </Flex>
  )
}

export default HistoricalDataModeBanner
